import React from 'react';
/**
 * Reporting Page — Australian financial reports (013-reporting-as-i)
 */
import { useState } from 'react';
import { PageHeader } from '../components/PageHeader';
import type { ReportFilters, ReportType } from '../types/report.types';
import { ReportCardsGrid } from './reporting/ReportCardsGrid';
import { CustomReportBuilderSection } from './reporting/CustomReportBuilderSection';
import { RecentReportsSection } from './reporting/RecentReportsSection';
import { ReportWizardModal } from './reporting/ReportWizardModal';
import { useReportingUserContext } from '../hooks/useReportingUserContext';

export function ReportingPage(): React.ReactElement {
  const { data: reportingContext } = useReportingUserContext();
  const [wizardOpen, setWizardOpen] = useState(false);
  const [wizardType, setWizardType] = useState<ReportType>('monthly_financial_summary');
  const [wizardTitle, setWizardTitle] = useState('');
  const [wizardFilters, setWizardFilters] = useState<ReportFilters>({});
  const [wizardStep, setWizardStep] = useState(1);

  const openWizard = (type: ReportType, title: string, step = 1, filters: ReportFilters = {}) => {
    setWizardType(type);
    setWizardTitle(title);
    setWizardStep(step);
    setWizardFilters(filters);
    setWizardOpen(true);
  };

  return (
    <div className="space-y-8">
      <PageHeader
        title="Reporting"
        description="Comprehensive reporting tools"
        helpSlug="reporting"
      />

      <ReportCardsGrid
        countryCode={reportingContext?.countryCode ?? 'AU'}
        onGenerate={(type, title) => openWizard(type, title)}
      />
      <CustomReportBuilderSection
        onBuild={(filters) => openWizard('custom', 'Custom Report', 1, filters)}
      />
      <RecentReportsSection />

      <ReportWizardModal
        isOpen={wizardOpen}
        reportType={wizardType}
        reportTitle={wizardTitle}
        initialFilters={wizardFilters}
        initialStep={wizardStep}
        onClose={() => setWizardOpen(false)}
      />

    </div>
  );
}
